'use client';
import BaseChart from '@/components/BaseChart';
import { annualIncomeConfig } from '@/utils/chart_configs';
import { getChartDataSets, getChartDataSetByGenderAndAge } from '@/utils/chart_service';
import { getYAxisDataPointsForBMIChartByUnit, getYAxisDataPointsForNetWorthChart } from '@/utils/data_points_service';
import { calculateAgeInMonthsWithTwoDates } from '@/utils/lm_utilities';
import _ceil from 'lodash/ceil';
import _round from 'lodash/round';
import _floor from 'lodash/floor';
import _first from 'lodash/first';
import {
  calculatePercentileFromPoints,
  calculatePercentileLinear,
  calculatePercentileWithZscores,
  getAxisPoints,
  getBlurbData,
} from '@/utils/charts_utils';
import { useState } from 'react';

const NetWorthChartsServerSideChart = ({ params, metaInfo, ...props }) => {
  const [blurbData, setBlurbData] = useState({
    ...getBlurbData(),
  });
  metaInfo.defaultMeasurementValue = metaInfo.chartData;

  const _getAxisPoints = (unit, calculated_age) => {
    // TODO // CURRENCY CONVERSION
    const temp_age = parseInt(calculated_age / 12);
    const options = getYAxisDataPointsForNetWorthChart(temp_age, 'USD');
    return getAxisPoints(options, temp_age);
  };

  const getDataPoints = async (gender, calculated_age, unit) => {
    let temp_age = parseInt(calculated_age / 12);
    // if (Number(calculated_age) > 240) {
    //   const remainder = calculated_age % 12;
    //   temp_age -= remainder;
    // }
    const response = await getChartDataSets('annual-income', gender, temp_age, unit);
    return response.json();
  };

  const calculatePercentile = async (value, formData, isNewChart) => {
    try {
      // Convert to years
      const calculated_age_months = calculateAgeInMonthsWithTwoDates(formData.dob, formData.md);
      const ageYears = parseInt(calculated_age_months / 12);

      // Age not supported
      if (ageYears < 15 || ageYears > 100) {
        console.warn('NettleWorth charts support only ages 15 to 100');
        return false;
      }

      let percentile = 0;
      const floor = ageYears - 1;
      const ceil = ageYears + 1;

      if (!isNewChart) {
        setBlurbData(getBlurbData(formData.unit, _first(metaInfo?.getChartDataSetByGenderAndAgeRes.charts)));

        percentile = calculatePercentileFromPoints(
          metaInfo?.getChartDataSetByGenderAndAgeRes,
          metaInfo?.getChartDataSetByGenderAndAgeCeilRes,
          ageYears,
          floor,
          ceil,
          Number(value),
        );
      } else {
        const floorData = await getChartDataSetByGenderAndAge('annual-income', formData.gender, floor);
        const floorJson = await floorData.json();
        setBlurbData(getBlurbData(formData.unit, _first(floorJson.charts)));

        const ceilData = await getChartDataSetByGenderAndAge('annual-income', formData.gender, ceil);
        const ceilJson = await ceilData.json();

        percentile = calculatePercentileFromPoints(floorJson, ceilJson, ageYears, floor, ceil, Number(value));
      }

      return {
        percentile: _round(percentile, 2),
        value: value,
      };
    } catch (err) {
      console.error('Error calculating percentile:', err);
      return null;
    }
  };

  return (
    <BaseChart
      params={params}
      metaInfo={metaInfo}
      {...annualIncomeConfig}
      getDataPoints={getDataPoints}
      getAxisPoints={_getAxisPoints}
      calculatePercentile={calculatePercentile}
      handleMeasurement={annualIncomeConfig.handleMeasurement}
      blurbData={blurbData}
    >
      {props.children}
    </BaseChart>
  );
};

export default NetWorthChartsServerSideChart;
